<!--
  The reordoring button of an <orderable-item>
  It connects to the OrderableItem to manage drag&drop, and button state
-->

<template>
  <el-button style="padding: 12px;" type="info"
    icon="el-icon-d-caret"
    :draggable="OrderableItem.disabled || OrderableItem.newItem ? 'false' : 'true'"
    @dragstart.native="OrderableItem.handleDragstart"
    @dragend.native="OrderableItem.handleDragend"
    @mousedown.native="OrderableItem.handleMousedown"
    @mouseup.native="OrderableItem.handleMouseup"
    :disabled="OrderableItem.disabled || OrderableItem.newItem"
    :tabindex="-1"></el-button>
</template>

<script>
export default {
  name: 'OrderableItemButton',
  inject: ['OrderableItem'],
}
</script>
